import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PasswordResetSuccess.css";

export default function PasswordResetSuccess() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="success-container">
      <div className="success-content">
        {/* Illustration SVG */}
        <div className="success-illustration">
          <svg width="300" height="280" viewBox="0 0 300 280" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Nuages */}
            <ellipse cx="80" cy="200" rx="40" ry="15" fill="#E8EEF5" />
            <ellipse cx="220" cy="210" rx="50" ry="18" fill="#E8EEF5" />
            <ellipse cx="150" cy="220" rx="80" ry="20" fill="#E8EEF5" />
            
            {/* Confettis */}
            <rect x="70" y="80" width="4" height="12" rx="2" fill="#3B82F6" transform="rotate(-30 70 80)" />
            <rect x="230" y="90" width="4" height="12" rx="2" fill="#EF4444" transform="rotate(30 230 90)" />
            <rect x="90" y="120" width="4" height="12" rx="2" fill="#EF4444" transform="rotate(-45 90 120)" />
            <rect x="210" y="140" width="4" height="12" rx="2" fill="#3B82F6" transform="rotate(45 210 140)" />
            <rect x="120" y="60" width="4" height="12" rx="2" fill="#EF4444" transform="rotate(-15 120 60)" />
            <rect x="180" y="70" width="4" height="12" rx="2" fill="#3B82F6" transform="rotate(15 180 70)" />
            
            {/* Personnage - Corps */}
            <path d="M150 180 L120 140 L130 135 L150 165 L170 135 L180 140 L150 180Z" fill="#3B82F6" />
            <ellipse cx="150" cy="195" rx="35" ry="25" fill="#3B82F6" />
            
            {/* Bras gauche levé */}
            <path d="M115 150 Q90 100 85 80" stroke="#F5D0B0" strokeWidth="12" strokeLinecap="round" fill="none" />
            <circle cx="85" cy="78" r="8" fill="#F5D0B0" />
            
            {/* Bras droit avec trophée */}
            <path d="M185 150 Q210 100 215 75" stroke="#F5D0B0" strokeWidth="12" strokeLinecap="round" fill="none" />
            
            {/* Trophée */}
            <path d="M200 55 L230 55 L225 75 L205 75 Z" fill="#EF4444" />
            <rect x="210" y="75" width="10" height="8" fill="#EF4444" />
            <rect x="205" y="83" width="20" height="5" rx="2" fill="#EF4444" />
            <circle cx="215" cy="45" r="10" fill="#EF4444" />
            <text x="215" y="50" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">★</text>
            
            {/* Tête */}
            <circle cx="150" cy="115" r="28" fill="#F5D0B0" />
            
            {/* Cheveux */}
            <path d="M122 105 Q130 85 150 85 Q170 85 178 105 Q180 95 175 90 Q160 75 150 75 Q140 75 125 90 Q120 95 122 105Z" fill="#1A1A1A" />
            <path d="M122 110 Q115 120 118 135" stroke="#1A1A1A" strokeWidth="8" strokeLinecap="round" fill="none" />
            <path d="M178 110 Q185 120 182 135" stroke="#1A1A1A" strokeWidth="8" strokeLinecap="round" fill="none" />
            
            {/* Visage souriant */}
            <circle cx="140" cy="112" r="3" fill="#1A1A1A" />
            <circle cx="160" cy="112" r="3" fill="#1A1A1A" />
            <path d="M140 125 Q150 135 160 125" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" fill="none" />
            
            {/* Sol */}
            <line x1="60" y1="240" x2="240" y2="240" stroke="#CBD5E1" strokeWidth="2" />
          </svg>
        </div>

        {/* Logo */}
        <h1 className="success-logo">WaaGo</h1>

        {/* Message */}
        <h2 className="success-title">C'est bon, votre mot de passe est tout neuf !</h2>
        <p className="success-subtitle">
          Vous pouvez maintenant vous connecter avec vos nouvelles informations. À bientôt sur votre espace !
        </p>

        {/* Bouton */}
        <button className="success-button" onClick={handleLogin}>
          Se connecter
        </button>
      </div>
    </div>
  );
}
